import { render } from "./XIconSolidFileText.vue?vue&type=template&id=43580643"
import script from "./XIconSolidFileText.vue?vue&type=script&lang=js"
export * from "./XIconSolidFileText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidFileText.vue"]])

export default __exports__